<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 19:29:09
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 14:44:39
-->
<template>
	<span>
		<DyAlert @success="onSuccess" ref="dyAlert"></DyAlert>
		<KsAlert @success="onSuccess" ref="ksAlert"></KsAlert>
		<SpAlert @success="onSuccess" ref="spAlert"></SpAlert>
	</span>
</template>
<script>
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
import DyAlert from './dyAlert.vue';
import KsAlert from './ksAlert.vue';
import SpAlert from './spAlert.vue';
const temPF = {
	[PLATFORM_DY.value]: 'dyAlert',
	[PLATFORM_KS.value]: 'ksAlert',
	[PLATFORM_SP.value]: 'spAlert',
};
export default {
	data() {
		return {
			platformId: '',
		};
	},
	methods: {
		init(link, platformId, call_id) {
			this.platformId = platformId;
			const ref = temPF[`${platformId}`] || 'dyAlert';
			this.$refs[ref].init(link, platformId, call_id);
		},
		onSuccess() {
			this.$emit('refresh');
		},
	},
	components: {
		DyAlert,
		KsAlert,
		SpAlert,
	},
};
</script>
